module.exports = __webpack_public_path__ + "img/Aasen_Signatur.6ba160ef.jpg";